import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { OTO_STORE } from 'services/consts';

import AppLogger from 'utils/AppLogger';

const initialState = {
	cart: {
		items: [],
		grandTotal: 0,
		shippingTotal: 0,
		subTotal: 0,
		isLoading: true
	},
	searchText: null,
	currentPage: 1
};

export const getUserCart = createAsyncThunk('otoStore/getUserCart', async (_, { rejectWithValue }) => {
	const axiosPrivate = useAxiosPrivate();
	try {
		const response = await axiosPrivate.post(OTO_STORE.GET_CART_DETAILS, {});
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		AppLogger.error(error);
		throw rejectWithValue('getUserCart error');
	}
});

export const updateUserCart = createAsyncThunk(
	'otoStore/updateUserCart',
	async (params, { getState, rejectWithValue }) => {
		const axiosPrivate = useAxiosPrivate();
		try {
			const cartData = getState()?.otoStore?.cart?.items || [];
			const currentCart = JSON.parse(JSON.stringify(cartData));
			const index = currentCart.findIndex((product) => product.productId === params.productId);

			if (params.quantity === 0) {
				currentCart.splice(index, 1);
			} else {
				if (index !== -1) {
					currentCart[index].quantity = params.quantity;
				} else {
					currentCart.push(params);
				}
			}

			const response = await axiosPrivate.post(OTO_STORE.UPDATE_CART, {
				items: currentCart
			});

			if (response.status === 200) {
				return response.data;
			} else {
				throw new Error(response.data);
			}
		} catch (error) {
			AppLogger.error(error);
			throw rejectWithValue('updateUserCart error');
		}
	}
);

const otoStore = createSlice({
	name: 'otoStore',
	initialState,
	reducers: {
		setSearchText: (state, { payload }) => ({
			...state,
			searchText: payload
		}),
		setCurrentPage: (state, { payload }) => ({
			...state,
			currentPage: payload
		})
	},
	extraReducers: (builder) => {
		builder
			.addCase(getUserCart.pending, (state) => ({
				...state,
				cart: {
					...state.cart,
					isLoading: true
				}
			}))
			.addCase(getUserCart.fulfilled, (state, { payload }) => ({
				...state,
				cart: {
					items: payload?.items || [],
					grandTotal: payload?.grandTotal,
					shippingTotal: payload?.shippingTotal,
					subTotal: payload?.subTotal,
					isLoading: false
				}
			}))
			.addCase(getUserCart.rejected, (state) => ({
				...state,
				cart: {
					...state.cart,
					isLoading: false
				}
			}))
			.addCase(updateUserCart.pending, (state) => ({
				...state,
				cart: {
					...state.cart,
					isLoading: true
				}
			}))
			.addCase(updateUserCart.fulfilled, (state, { payload }) => ({
				...state,
				cart: {
					items: payload?.items || [],
					grandTotal: payload?.grandTotal,
					shippingTotal: payload?.shippingTotal,
					subTotal: payload?.subTotal,
					isLoading: false
				}
			}))
			.addCase(updateUserCart.rejected, (state) => ({
				...state,
				cart: {
					...state.cart,
					isLoading: false
				}
			}));
	}
});

export const { setSearchText, setCurrentPage } = otoStore.actions;

export default otoStore.reducer;
